// 驾驶超时
const driveTimeout = (resolve) => {
  import('components/activeSafety/activeSafety.driveTimeout').then((module) => {
    resolve(module)
  })
}

// 司机出勤报表---司机出勤明细报表
const driverDetail = (resolve) => {
  import('components/activeSafety/activeSafety.driverDetail').then((module) => {
    resolve(module)
  })
}

// 驾驶员身份识别
const driverIdentification = (resolve) => {
  import('components/activeSafety/activeSafety.driverIdentification').then((module) => {
    resolve(module)
  })
}

// 驾驶员不匹配
const DriverMismatch = (resolve) => {
  import('components/activeSafety/activeSafety.DriverMismatch').then((module) => {
    resolve(module)
  })
}

// 司机出勤报表---司机出勤统计报表
const driverSummery = (resolve) => {
  import('components/activeSafety/activeSafety.driverSummery').then((module) => {
    resolve(module)
  })
}

// DSM报表-DSM明细表
const DsmDetail = (resolve) => {
  import('components/activeSafety/activeSafety.DsmDetail').then((module) => {
    resolve(module)
  })
}

// DSM报表-DSM统计表
const DsmSummery = (resolve) => {
  import('components/activeSafety/activeSafety.DsmSummery').then((module) => {
    resolve(module)
  })
}

// BSD报表-BSD明细表
const BsdDetail = (resolve) => {
  import('components/activeSafety/activeSafety.BsdDetail').then((module) => {
    resolve(module)
  })
}

// BSD报表-BSD统计表
const BsdSummery = (resolve) => {
  import('components/activeSafety/activeSafety.BsdSummery').then((module) => {
    resolve(module)
  })
}

// 疫情明细表
const epidemicDetail = (resolve) => {
  import('components/activeSafety/activeSafety.epidemicDetail').then((module) => {
    resolve(module)
  })
}

// 健康码上传
const healthCodeUpload = (resolve) => {
  import('components/activeSafety/activeSafety.healthCodeUpload').then((module) => {
    resolve(module)
  })
}

// 疫情统计表
const epidemicSummery = (resolve) => {
  import('components/activeSafety/activeSafety.epidemicSummery').then((module) => {
    resolve(module)
  })
}

// 人脸识别
const FaceRecognition = (resolve) => {
  import('components/activeSafety/activeSafety.FaceRecognition').then((module) => {
    resolve(module)
  })
}

// adas报警明细表(易甲文ADAS报表)
const IcarAdasDetail = (resolve) => {
  import('components/activeSafety/activeSafety.IcarAdasDetail').then((module) => {
    resolve(module)
  })
}

// adas报警汇总表(易甲文ADAS报表)
const IcarAdasSummery = (resolve) => {
  import('components/activeSafety/activeSafety.IcarAdasSummery').then((module) => {
    resolve(module)
  })
}

// 速度报表---行驶速度分析
const speedAnalysis = (resolve) => {
  import('components/activeSafety/activeSafety.speedAnalysis').then((module) => {
    resolve(module)
  })
}

// 速度报表---超速报警明细表
const speedDetail = (resolve) => {
  import('components/activeSafety/activeSafety.speedDetail').then((module) => {
    resolve(module)
  })
}

// 超速报警汇总报表(速度报表)
const speedSummery = (resolve) => {
  import('components/activeSafety/activeSafety.speedSummery').then((module) => {
    resolve(module)
  })
}

// 驾驶员评分
const driverGrade = (resolve) => {
  import('components/activeSafety/activeSafety.driverGrade').then((module) => {
    resolve(module)
  })
}

// 驾驶员行为分析
const driverBehaviorAnaly = (resolve) => {
  import('components/activeSafety/activeSafety.driverBehaviorAnaly').then((module) => {
    resolve(module)
  })
}

// 企业统计分析
const statisticalAnalyCompany = (resolve) => {
  import('components/activeSafety/activeSafety.statisticalAnalyCompany').then((module) => {
    resolve(module)
  })
}

// 驾驶员统计分析
const statisticalAnalyDriver = (resolve) => {
  import('components/activeSafety/activeSafety.statisticalAnalyDriver').then((module) => {
    resolve(module)
  })
}

// 车辆统计分析
const statisticalAnalyVehicle = (resolve) => {
  import('components/activeSafety/activeSafety.statisticalAnalyVehicle').then((module) => {
    resolve(module)
  })
}

// 报警联动
const alarmaction = (resolve) => {
  import('components/activeSafety/activeSafety.alarmaction').then((module) => {
    resolve(module)
  })
}

// 附件上传规则
const fileRuleAction = (resolve) => {
  import('components/activeSafety/activeSafety.fileRuleAction').then((module) => {
    resolve(module)
  })
}

// 808报警设备上传规则关联
const devAlarmRulePermit = (resolve) => {
  import('components/activeSafety/activeSafety.devAlarmRulePermit').then((module) => {
    resolve(module)
  })
}

// 主动安全汇总
const alarmSummary = (resolve) => {
  import('components/activeSafety/activeSafety.alarmSummary').then((module) => {
    resolve(module)
  })
}

// 日本itsherpa-非法报警
const IllegalAlarm = (resolve) => {
  import('components/activeSafety/activeSafety.IllegalAlarm').then((module) => {
    resolve(module)
  })
}
const activeSafetyRouter = {
  activeSafetyPath: [{
    path: '/activeSafety/driveTimeout', // 驾驶超时
    component: driveTimeout
  },
  {
    path: '/activeSafety/driverDetail', // 司机出勤明细报表
    component: driverDetail
  },
  {
    path: '/activeSafety/driverIdentification', // 驾驶员身份识别
    component: driverIdentification
  },
  {
    path: '/activeSafety/DriverMismatch', // 驾驶员不匹配
    component: DriverMismatch
  },
  {
    path: '/activeSafety/driverSummery', // 司机出勤统计报表
    component: driverSummery
  },
  {
    path: '/activeSafety/DsmDetail', // DSM明细表
    component: DsmDetail
  },
  {
    path: '/activeSafety/DsmSummery', // DSM统计表
    component: DsmSummery
  },
  {
    path: '/activeSafety/FaceRecognition', // 人脸识别
    component: FaceRecognition
  },
  {
    path: '/activeSafety/IcarAdasDetail', // adas报警明细表
    component: IcarAdasDetail
  },
  {
    path: '/activeSafety/alarmSummary', // 主动安全汇总
    component: alarmSummary
  },
  {
    path: '/activeSafety/IcarAdasSummery', // adas报警汇总表
    component: IcarAdasSummery
  },
  {
    path: '/activeSafety/speedAnalysis', // 行驶速度分析
    component: speedAnalysis
  },
  {
    path: '/activeSafety/speedDetail', // 超速报警明细表
    component: speedDetail
  },
  {
    path: '/activeSafety/speedSummery', // 超速报警汇总报表
    component: speedSummery
  },
  {
    path: '/activeSafety/driverGrade', // 驾驶员评分
    component: driverGrade
  },
  {
    path: '/activeSafety/driverBehaviorAnaly', // 驾驶员行为分析
    component: driverBehaviorAnaly
  },
  {
    path: '/activeSafety/statisticalAnalyCompany', // 企业统计分析
    component: statisticalAnalyCompany
  },
  {
    path: '/activeSafety/statisticalAnalyDriver', // 驾驶员统计分析
    component: statisticalAnalyDriver
  },
  {
    path: '/activeSafety/statisticalAnalyVehicle', // 车辆统计分析
    component: statisticalAnalyVehicle
  },
  {
    path: '/activeSafety/alarmaction', // adas报警联动
    component: alarmaction
  },
  {
    path: '/activeSafety/fileRuleAction', // 附件上传规则
    component: fileRuleAction
  },
  {
    path: '/activeSafety/devAlarmRulePermit', // 808报警设备上传规则关联
    component: devAlarmRulePermit
  },
  {
    path: '/activeSafety/BsdDetail', // BSD明细表
    component: BsdDetail
  },
  {
    path: '/activeSafety/BsdSummery', // BSD统计表
    component: BsdSummery
  },
  {
    path: '/activeSafety/epidemicDetail', // 疫情明细表
    component: epidemicDetail
  },
  {
    path: '/activeSafety/healthCodeUpload', // 健康码上传
    component: healthCodeUpload
  },
  {
    path: '/activeSafety/epidemicSummery', // 疫情统计表
    component: epidemicSummery
  },
  {
    path: '/activeSafety/IllegalAlarm', // 日本-非法报警
    component: IllegalAlarm
  }
  ]
}

export default activeSafetyRouter



// WEBPACK FOOTER //
// ./src/router/activeSafety.js